export default function ProblemsSolved() {
  const problems = [
    { icon: 'ri-price-tag-3-line', title: 'Менеджеры сразу дают скидки', desc: 'Не умеют продавать ценность продукта и защищать маржу. Скидка становится единственным аргументом в переговорах.' },
    { icon: 'ri-user-search-line', title: 'Не выходят на ЛПР', desc: 'Общаются только с исполнителями и не знают, как выйти на лицо, принимающее решение. Сделка застревает на среднем уровне.' },
    { icon: 'ri-file-text-line', title: 'Теряют сделки после КП', desc: 'Отправляют коммерческое предложение и ждут. Нет стратегии follow-up и управления следующими шагами клиента.' },
    { icon: 'ri-calendar-check-line', title: 'Не умеют вести длинные сделки', desc: 'Цикл сделки 3–12 месяцев, а менеджер работает как с быстрой продажей. Нет системы управления воронкой.' },
    { icon: 'ri-emotion-unhappy-line', title: 'Боятся возражений', desc: 'Теряются при работе с закупщиками и финансовыми директорами. Не знают, как отвечать на сложные возражения.' },
    { icon: 'ri-presentation-line', title: 'Не умеют проводить встречи', desc: 'Презентуют продукт вместо диагностики бизнеса клиента. Не готовятся к встречам — работают экспромтом.' },
    { icon: 'ri-arrow-right-circle-line', title: 'Не контролируют следующий шаг', desc: 'Завершают разговор без чёткой договорённости о следующем шаге. Сделка «зависает» на неопределённый срок.' },
    { icon: 'ri-shuffle-line', title: 'Работают «по ситуации»', desc: 'Нет единого стандарта продаж. Каждый менеджер продаёт по-своему. Результат непредсказуем.' },
    { icon: 'ri-user-star-line', title: 'Продажи зависят от одного менеджера', desc: 'Вся выручка держится на одном «звезде». При его уходе бизнес теряет значительную долю продаж.' },
    { icon: 'ri-money-dollar-circle-line', title: 'Не умеют продавать ценность', desc: 'Говорят про характеристики продукта, а не про бизнес-результат для клиента. Клиент не видит ROI.' },
    { icon: 'ri-shield-user-line', title: 'Боятся коммерческих директоров', desc: 'Теряются перед опытными переговорщиками со стороны клиента. Не умеют вести переговоры на равных.' },
    { icon: 'ri-bar-chart-line', title: 'Нет системности', desc: 'Отсутствуют регламенты, скрипты, стандарты. Нельзя масштабировать успех и обучать новичков.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            <i className="ri-error-warning-line"></i>
            Системные проблемы
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Какие проблемы решает тренинг
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Эти проблемы знакомы большинству компаний, работающих в B2B-сегменте. Тренинг даёт системное решение для каждой из них.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {problems.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-5 md:p-6 border border-gray-100 hover:border-teal-100 hover:bg-teal-50/30 transition-colors group">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 bg-red-50 rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5 group-hover:bg-teal-100 transition-colors">
                  <i className={`${item.icon} text-red-500 group-hover:text-teal-600 transition-colors text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}